import Component from './Component'

export default class KeyboardWatcher extends Component {

	static _type = 'KeyboardWatcher'

	tether () {
		super.tether()

		// Create bound event handlers and register them
		this.keydownListener = KeyboardWatcher._keydownListener.bind(this)
		this.keypressListener = KeyboardWatcher._keypressListener.bind(this)
		$(window).on('keydown', this.keydownListener)						// jQuery event
		$(window).on('keypress', this.keypressListener)						// jQuery event
	}

	static _keydownListener (event) {
		if ((event.target.tagName != 'INPUT' || event.target.classList.contains('permit-keyboard-watcher')) && ('keydown' in this.params)) {
			this.params.keydown(event)
		}
	}

	static _keypressListener (event) {
		if ((event.target.tagName != 'INPUT' || event.target.classList.contains('permit-keyboard-watcher')) && ('keypress' in this.params)) {
			this.params.keypress(event)
		}
	}

	destroy () {

		// Unregister event handlers
		$(window).off('keydown', this.keydownListener)
		$(window).off('keypress', this.keypressListener)

		super.destroy()
	}
}
